import React from "react";

const Notifications=()=>{
    return <div>
        <p>No New Notifications</p>
    </div>
}

export default Notifications;